import SvgIcon from '@material-ui/core/SvgIcon';

const WarningIcon = ({ viewBox, color='#ff51ca', ...rest }) => (
  <SvgIcon viewBox={viewBox || "0 0 33 32"} {...rest}>
    <path d="m16.501 0c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16zm.15 24.822c-.826 0-1.496-.67-1.496-1.495 0-.826.67-1.495 1.496-1.495.825 0 1.495.67 1.495 1.495 0 .826-.67 1.495-1.495 1.495zm1.495-15.616-.434 9.311c0 .675-.542 1.221-1.21 1.221s-1.21-.546-1.21-1.22l-.434-9.307v-.004c-.026-.61.281-1.184.8-1.496s1.166-.312 1.685 0c.518.312.826.887.8 1.496h.003z" fill={color}>
    </path>
  </SvgIcon>
);

export default WarningIcon;

